export default "__VITE_ASSET__C1Ht6ubT__"